
const numberFormatter = Intl.NumberFormat('tr-TR',{
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});
export const formattedPrice = (num: number) => numberFormatter.format(num);
